<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-28 10:31:17
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-10 14:32:08
-->
<template>
  <div class="container">
    <div class="container_title">订单详情</div>

    <el-alert
      v-if="information.cancelStatus == 1 || information.cancelStatus == 2"
      :type="information.cancelStatus == 1 ? 'warning' : 'error'"
      :class="[
        'alert-box',
        information.cancelStatus == 1 ? 'warning-border' : 'error-border'
      ]"
      show-icon
      :closable="false"
    >
      <div slot="title">
        <div class="common title">{{ information.cancelRemark }}</div>
        <div class="common tips">
          {{
            information.cancelStatus == 1
              ? '订单操作暂时终止'
              : '该订单中企业已使用服务券，服务券退回。该订单操作已被终止'
          }}
        </div>
        <div class="common record-tip" @click="record($route.query.id)">
          审核记录
        </div>
      </div>
    </el-alert>
    <div class="container_time">
      <div>下单时间：{{ information.createTime }}</div>
      <div>
        合同服务时间：{{
          information.contractServiceStartStr
            ? information.contractServiceStartStr +
              ' 至 ' +
              information.contractServiceEndStr
            : '-'
        }}
      </div>
      <div
        v-if="information.orderStatus === 2 || information.orderStatus === 3"
      >
        企业确认时间：{{ information.entConfirmTime }}
      </div>
    </div>

    <div class="container_content">
      当前订单状态：{{ information.orderStatus | reviewStatus }}
      <div
        v-if="information.orderStatus === 4 && information.invalidRemark"
        class="failure-tips"
      >
        {{ information.invalidRemark }}
      </div>
      <div
        v-if="information.orderStatus === 4 && !information.invalidRemark"
        class="failure-tips"
      >
        {{
          information.failureStatus === 2
            ? '企业 （' +
              information.concat +
              ') ' +
              '取消订单，订单已失效,操作时间：' +
              information.entConfirmTime
            : '超过90天未确认订单，订单已失效'
        }}
      </div>
      <div
        class="confirm_order"
        v-if="
          (componentId === '机构' || componentId === '服务机构') &&
          information.orderStatus === 0
        "
      >
        <span>请先和买家沟通后，再修改订单金额</span>
        <el-form
          :model="confirmOrder"
          ref="numberValidateForm"
          label-width="120px"
          class="demo-ruleForm"
          :rules="rules"
        >
          <el-form-item label="合同服务时间：" prop="timeRange">
            <el-date-picker
              v-model="confirmOrder.timeRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
              >
            </el-date-picker>
          </el-form-item>
          <div class="flex-box">
            <el-form-item label="修改后的价格：" prop="afterPrice">
              <el-input
                type="number"
                v-model="confirmOrder.afterPrice"
                placeholder=""
              ></el-input>
            </el-form-item>
            <span class="money"> 元</span>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('numberValidateForm')"
                >确定订单</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="container_content">
      <div class="voucher">买家信息</div>
      <div class="contract">
        <span>企业名称：</span>
        {{ information.entName }}
      </div>
      <div class="contract">
        <span>联系方式：</span>
        {{ information.concat }}, {{ information.concatTel }};
        {{ information.address }}
      </div>
      <div class="voucher">订单信息</div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px; font-weight: 500"
        :header-cell-style="{
          background: '#fff',
          color: '#000',
          fontWeight: 500
        }"
      >
        <el-table-column
          align="center"
          prop="goodsName"
          label="商品名称"
          width="400"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span
              class="tabel_color"
              @click="
                commodityDetails(scope.row.goodsId, scope.row.goodsStatus)
              "
              >{{ scope.row.goodsName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" prop="num" label="数量" width="180">
        </el-table-column>
        <el-table-column align="center" prop="price" label="商品价格（元）">
          <template slot-scope="scope">
            {{ scope.row.price === null ? '面议' : scope.row.price }}
            <!-- {{ scope.row.price || '面议' }} -->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="deductionPrice"
          label="服务券抵扣（元）"
        >
          <template slot-scope="scope">{{
            scope.row.deductionPrice | deductionPriceStatus
          }}</template>
        </el-table-column>
      </el-table>
      <div
        class="actual_payment"
        v-if="information.orderStatus === 2 || information.orderStatus === 3"
      >
        实付款：<span>{{ information.realPay }}元</span>
      </div>
    </div>
    <div class="container_content" v-if="information.orderStatus === 3">
      <div class="voucher">企业评价</div>
      <div class="contract">
        <span class="satisfied">满意度：</span>
        <!-- <el-rate v-model="information.evaluateLevel" disabled :max="3">
        </el-rate> -->
        <div class="evaluate">
          {{ information.evaluateLevel | evaluateStatus }}
        </div>
      </div>
      <div class="contract">
        <span class="eval_time">评价反馈：</span>
        <div class="eval_content">
          {{ information.evaluateFeedback || '-' }}
        </div>
      </div>
      <div class="contract">
        <span>评价时间：</span>
        {{ information.evaluateTime }}
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      top="300px"
      width="18%"
    >
      <span class="no_order">是否确认订单？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('numberValidateForm', 0)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="审核记录" :visible.sync="cancelOrderVisiblel" width="30%">
      <div class="title">展示取消订单的审核记录</div>
      <img v-if="!activities.length" src="@/assets/es-sfss.png" alt="" />
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          color="#1890ff"
          :size="activity.size"
        >
          <h4>{{ activity.statusName }}</h4>
          <p>备注：{{ activity.remark || '-' }}</p>
          <p>操作人：{{ activity.createBy || '-' }}</p>
          <p>操作时间：{{ activity.createTime || '-' }}</p>
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import { orderDetail, orgConfirmOrder } from '@api/orderManagement'
import { listByCancelRecord } from '@api/yardIntermediary/cancelOrder'
export default {
  data() {
    const _this = this
    const validateTimeRange = (rule, value, cb) => {
      if (!value) {
        _this.confirmOrder.startTime = ''
        _this.confirmOrder.endTime = ''
        return cb(new Error('请选择合同服务时间'))
      } else {
        _this.confirmOrder.startTime = value[0]
        _this.confirmOrder.endTime = value[1]
        cb()
      }
    }
    return {
      rules: {
        timeRange: [
          {
            required: true,
            validator: validateTimeRange,
            trigger: 'change'
          }
        ],
        afterPrice: [
          { required: true, message: '请输入金额' },
          {
            pattern: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
            message: '请输入正确金额'
          }
        ]
      },
      cancelOrderVisiblel: false,
      dialogVisible: false,
      information: {},
      pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, // 手机号验证

      tableData: [
        {
          goodsName: '',
          num: 1,
          price: '面议',
          goodsOrg: '',
          goodsId: '',
          deductionPrice: '',
          goodsStatus: ''
        }
      ],
      confirmOrder: {
        afterPrice: '',
        id: this.$route.query.id,
        timeRange: [],
        startTime: '',
        entTime: ''
      },
      value: 3,
      roleText: '',
      activities: []
    }
  },
  computed: {
    componentId() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.roleText = this.$store.state.user.userInfo.roleText

      return this.roleText
    }
  },
  filters: {
    reviewStatus(key) {
      let val = ''
      switch (key) {
        case 0:
          val = '待机构确认'
          break
        case 1:
          val = '待企业确认'
          break
        case 2:
          val = '待评价'
          break
        case 3:
          val = '已完成'
          break
        case 4:
          val = '已失效'
          break

        default:
          break
      }
      return val
    },
    evaluateStatus(key) {
      let val = ''
      switch (key) {
        case 1:
          val = '差评'
          break
        case 3:
          val = '好评'
          break

        default:
          break
      }
      return val
    },
    deductionPriceStatus(val) {
      let v = ''
      switch (val) {
        case 0:
          v = 0
          break
        case val:
          v = val
          break
        default:
          break
      }
      if (val === null) {
        v = '-'
      }
      return v
    }
  },
  mounted() {
    this.detailsInfor()
  },
  methods: {
    record(id) {
      this.cancelOrderVisiblel = true
      this.listByCancelRecord(id)
    },
    listByCancelRecord(id) {
      listByCancelRecord({ id: id }).then(res => {
        if (res.data.code == '0000') {
          this.activities = res.data.data || []
        }
      })
    },
    submitForm(formName, m) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (m === 0) {
            let params = {
              id: this.confirmOrder.id,
              afterPrice: this.confirmOrder.afterPrice,
              endTime: this.confirmOrder.endTime,
              startTime: this.confirmOrder.startTime
            }
            orgConfirmOrder(params).then(res => {
              const { code, data } = res.data
              if (code === '0000') {
                this.$message({
                  message: '确认订单成功',
                  type: 'success'
                })
                setTimeout(() => {
                  this.dialogVisible = false
                  location.reload()
                }, 500)
              }
            })
          } else {
            this.dialogVisible = true
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    commodityDetails(e, is) {
      if (is === 0) {
        this.$message({
          message: '该商品已被删除，无法查看',
          type: 'warning'
        })
      } else {
        this.$router.push({ name: 'productOrder', query: { id: e } })
      }
    },
    detailsInfor() {
      orderDetail({ id: this.$route.query.id }).then(res => {
        const { code, data } = res.data
        if (code === '0000') {
          this.information = data

          Object.keys(this.tableData[0]).map(value => {
            // this.tableData[0][value] = data[value] ? data[value] : '-'
            this.tableData[0][value] = data[value]
          })
          this.tableData[0].num = 1
          console.log(this.tableData[0])
        }
      })
    },
    // 返回首页
    returnRouter() {
      this.$router.push({ name: 'orderList' })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-form {
  display: flex;
}
/deep/.el-dialog {
  .title {
    background: rgb(244, 249, 252);
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__header {
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .el-dialog__body {
    height: 600px;
    overflow: auto;
    img {
      display: block;
      margin: 20px auto;
    }
  }
}
.container {
  font-size: 16px;
  .warning-border {
    border: 1px solid rgba(255, 229, 143, 1);
  }
  .error-border {
    border: 1px solid rgba(255, 163, 158, 1);
  }
  .alert-box {
    margin-bottom: 10px;
    padding: 20px;
    font-size: 14px;
    .common {
      line-height: 22px;
    }
    .title {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);
    }
    .tips {
      color: #ccc;
    }
    .record-tip {
      color: rgb(56, 160, 255);
      cursor: pointer;
    }
  }
  .container_title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    .el-icon-back {
      cursor: pointer;
    }
  }
  .c1 {
    background: rgb(223, 223, 165);
    border: 1px solid orange;
  }
  .c2 {
    background: rgb(247, 206, 206);
    border: 1px solid rgb(243, 63, 63);
  }
  .container_head {
    width: 70%;
    font-size: 14px;
    padding: 10px 30px;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 15px;
    > p {
      margin: 7px 0;
    }
    > p:nth-child(1) {
      font-size: 16px;
    }
    > p:nth-child(3) {
      cursor: pointer;
      color: #1890ff;
    }
  }
  .container_time {
    width: 70%;
    display: flex;
    font-family: monospace;
    flex-wrap: wrap;
    line-height: 24px;
    div {
      margin-right: 10px;
    }
  }
  .container_content {
    width: 70%;
    margin-top: 20px;
    padding: 20px 30px;
    border: 1px solid rgba($color: #000000, $alpha: 0.1);
    .failure-tips {
      margin-top: 5px;
    }
    .voucher {
      padding-bottom: 10px;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
      font-size: 16px;
      color: #999;
      margin-right: 6px;
      .voucher_right {
        font-size: 20px;
        color: #f00;
        font-weight: 600;
      }
    }
    .contract {
      margin: 20px 0;
      font-size: 16px;
      display: flex;
      span {
        margin-right: 10px;
      }
      .eval_time {
        display: inline-block;
        // width: 280px;
        // width: 7.8%;
        // width: 85px;
      }
      .eval_content {
        width: 80%;
      }
      .satisfied {
        margin-left: 17px;
      }
      .evaluate {
        font-size: 16px;
        color: #333;
      }
    }
    .file_list {
      span {
        margin-right: 10px;
      }
      .file {
        display: inline-block;
        padding: 6px 10px;
        height: 30px;
        border-radius: 4px;
        background-color: rgb(247, 247, 247);
        cursor: pointer;
        margin-right: 20px;
        i {
          font-size: 15px;
          color: rgb(51, 153, 255);
          margin-right: 10px;
        }
      }
    }
    .actual_payment {
      margin-top: 20px;
      text-align: right;
      span {
        font-size: 18px;
      }
    }
    .confirm_order {
      .demo-ruleForm {
        display: block;
        .flex-box {
          display: flex;
        }
        /deep/.el-range-separator {
          width: 6%;
        }
      }
      span {
        display: inline-block;
        margin: 4px 0 20px;
      }
      .money {
        line-height: 30px;
        margin-left: 10px;
      }
    }
  }

  .details_footer {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-10%);
    padding-bottom: 20px;
  }
  .tabel_color {
    color: rgb(56, 160, 255);
    cursor: pointer;
  }
  .no_order {
    display: inline-block;
    width: 100%;
    font-size: 20px;
    text-align: center;
  }
}
</style>
